import { BASE_PUBLIC_V2_PATH } from '../../shared/public/constants/path.constants';

// Les huit autres pages éditoriales du menu viendront s'ajouter ici.
export const PUBLIC_EDITORIAL_APP_PATHS = {
  OUR_VALUES: `${BASE_PUBLIC_V2_PATH}/nos-valeurs`,
  OUR_PRODUCTS: `${BASE_PUBLIC_V2_PATH}/nos-produits`,
  ZERO_WASTE: `${BASE_PUBLIC_V2_PATH}/zero-dechets`,
  ENTERPRISE_OFFER: `${BASE_PUBLIC_V2_PATH}/offre-entreprise`,
  FRUIT_BASKET: `${BASE_PUBLIC_V2_PATH}/corbeille-fruit`,
  // Le legacy sert cette page sous le sigle opaque /c-c-m.
  GROUP_ORDER: `${BASE_PUBLIC_V2_PATH}/commande-groupee`,
  ECO_POINTS: `${BASE_PUBLIC_V2_PATH}/eco-points`,
};
